/**
 * A funnel step path as one URL segment: `/oferta/<slug>/<path>` is matched by a single
 * `[step]` route, so a slash, `?`, `#` or whitespace inside it would make the step unreachable.
 * Those become `-`; the leading slash older funnels carry is dropped.
 */
export const normalizeFunnelStepPath = (path: string) => {
  const normalized = path
    .trim()
    .replace(/^\/+/, "")
    .replace(/[/?#\s]+/g, "-");

  return normalized || "checkout";
};
